module.exports = "/_next/static/images/bd-102dcced9075aecbfee9e0a364b041a0.svg";